export default "__VITE_ASSET__stX85YUF__"